/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    d="M12 0a.9231.9231 0 1 1 0 1.8461C6.3922 1.8461 1.8461 6.3921 1.8461 12c0 5.6078 4.546 10.1538 10.1539 10.1538 5.6078 0 10.1538-4.546 10.1538-10.1538A.9231.9231 0 0 1 24 12c0 6.6274-5.3726 12-12 12S0 18.6274 0 12 5.3726 0 12 0Zm0 4.92c.4916 0 .9715.0501 1.4349.1455l-.0002 2.3065-3.0303 3.0325-.1558.175-.1264.1851c-.5457.8776-.475 1.935.1418 2.6769l.1405.154.1609.1464.171.128c.8193.555 1.9226.5123 2.6982-.128l.1609-.1464 3.0232-3.0262 2.3172.0025c.0945.4613.1441.939.1441 1.4282 0 3.9102-3.1698 7.08-7.08 7.08S4.92 15.9102 4.92 12 8.0898 4.92 12 4.92ZM19.2615.1745c.5297 0 .9674.3935 1.0366.9042l.0096.142-.0012 2.4716h2.4737c.1847 0 .3644.0489.5218.1394l.1136.0757.1036.0906c.3718.371.4061.9522.1027 1.362l-.1012.1175-3.7532 3.7606-3.6999-.001-3.4149 3.4156a.923.923 0 0 1-1.3054 0c-.3277-.3277-.3575-.8405-.0894-1.2019l.0894-.1035 3.4216-3.4222.0003-3.6842L18.5211.4816a1.046 1.046 0 0 1 .7404-.3071Z"
  />,
  'MenuInsightFilled'
);
